import { render, staticRenderFns } from "./DatasetTableData.vue?vue&type=template&id=53a40ed2&scoped=true"
import script from "./DatasetTableData.vue?vue&type=script&lang=js"
export * from "./DatasetTableData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a40ed2",
  null
  
)

export default component.exports